import { Component, computed, input } from '@angular/core';

import {
  formatCellValue,
  formatJsonForTooltip,
  processJsonValue
} from '@shared/components/table/table-cell/utils';
import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

/**
 * Fallback cell for object/array values. Renders a compact JSON preview in the
 * cell (with a pretty-printed tooltip) instead of letting complex values
 * stringify to "[object Object]" through the default string path.
 */
@Component({
  selector: 'app-json-cell',
  standalone: true,
  imports: [TooltipComponent],
  templateUrl: './json-cell.component.html'
})
export class JsonCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'json');

  value = input<unknown | undefined>(undefined);

  protected compact = computed<string>(() => processJsonValue(this.value()));
  protected tooltipContent = computed<string>(() => formatJsonForTooltip(this.value()));
}
